export const Products = {
  dressings: {
    title: "Salad Dressings",
    intro:
      "Give your meal a makeover with dressings inspired by the Food Network Kitchen<sup>TM</sup>.",
    header: {
      left: "garlic.png",
      right: "herbs.png"
    },
    items: [
      {
        id: "italianHerb",
        name: "Italian Herb & Garlic",
        description:
          "This thick blend of bold Italian seasonings makes a delicious marinade for grilled chicken or the perfect dressing for any salad.",
        image: {
          small: "/img/products/small/italianHerb.jpg",
          full: "/img/products/full/italianHerb.png"
        },
        recipes: ["chickenAndPotatoes", "tortelliniSalad"], //list of paired recipes
        nutrition: {
          servings: 12,
          servingSize: {
            tbps: 2,
            g: 31
          },
          calories: {
            base: 44,
            fat: 34
          },
          fat: {
            total: {
              percent: 6,
              g: 4
            },
            sat: {
              percent: 0,
              g: 0
            },
            trans: {
              g: 0
            }
          },
          cholesterol: {
            percent: 0,
            mg: 0
          },
          sodium: {
            percent: 13,
            mg: 320
          },
          carbs: {
            total: {
              percent: 1,
              g: 2
            },
            fiber: {
              percent: 0,
              g: 0
            },
            sugar: {
              g: 1
            }
          },
          protein: {
            g: 0
          },
          vitamin: {
            a: 2,
            c: 2,
            calcium: 0,
            iron: 0
          }
        },
        ingredients:
          "Water, red wine vinegar, extra virgin olive oil, onion, salt, garlic, sugar, onion juice concentrate, red bell pepper, spices, xanthan gum, romano cheese type flavor concentrate (romano cheese made from cow's milk and cheddar cheese [pasteurized milk, cheese culture, salt, enzymes], water, salt, disodium phosphate, enzymes), flavor (water, cream [from milk], salt, butterfat, natural flavor, xanthan gum), lemon juice concentrate, oregano, basil, potassium sorbate and calcium disodium edta (to preserve quality).",
        allergy: "Milk."
      },
      {
        id: "frenchBalsamic",
        name: "French Style Dijon Balsamic",
        description:
          "Packed with bold Dijon flavors and the rich taste of balsamic vinegar, this dressing will dial up any salad or wrap.",
        image: {
          small: "/img/products/small/frenchBalsamic.jpg",
          full: "/img/products/full/frenchBalsamic.png"
        },
        recipes: ["salmonCakes", "steakBlueCheese"], //list of paired recipes
        nutrition: {
          servings: 12,
          servingSize: {
            tbps: 2,
            g: 30
          },
          calories: {
            base: 40,
            fat: 25
          },
          fat: {
            total: {
              percent: 4,
              g: 2.5
            },
            sat: {
              percent: 0,
              g: 0
            },
            trans: {
              g: 0
            }
          },
          cholesterol: {
            percent: 0,
            mg: 0
          },
          sodium: {
            percent: 12,
            mg: 280
          },
          carbs: {
            total: {
              percent: 1,
              g: 4
            },
            fiber: {
              percent: 0,
              g: 0
            },
            sugar: {
              g: 3
            }
          },
          protein: {
            g: 0
          },
          vitamin: {
            a: 0,
            c: 2,
            calcium: 0,
            iron: 0
          }
        },
        ingredients:
          "Water, balsamic vinegar, distilled white vinegar, sugar, soybean oil, dijon mustard (water, vinegar, mustard seed, salt, white wine, fruit pectin, citric acid, tartaric acid, sugar, spice), extra virgin olive oil, salt, lemon juice concentrate, dried garlic, dried onion, onion juice concentrate, xanthan gum, spices, paprika, potassium sorbate and calcium disodium edta (to preserve quality)."
      },
      {
        id: "parmCaesar",
        name: "Creamy Parmesan Caesar",
        description:
          "Made with fresh cracked black pepper and real Parmesan and Romano cheeses, this indulgent dressing takes Caesar Salad to the next level.",
        image: {
          small: "/img/products/small/parmCaesar.jpg",
          full: "/img/products/full/parmCaesar.png"
        },
        recipes: ["baconCaesarSalad", "caesarPizza"], //list of paired recipes
        nutrition: {
          servings: 12,
          servingSize: {
            tbps: 2,
            g: 30
          },
          calories: {
            base: 130,
            fat: 110
          },
          fat: {
            total: {
              percent: 18,
              g: 12
            },
            sat: {
              percent: 13,
              g: 2.5
            },
            trans: {
              g: 0
            }
          },
          cholesterol: {
            percent: 5,
            mg: 15
          },
          sodium: {
            percent: 15,
            mg: 350
          },
          carbs: {
            total: {
              percent: 1,
              g: 2
            },
            fiber: {
              percent: 0,
              g: 0
            },
            sugar: {
              g: 1
            }
          },
          protein: {
            g: 1
          },
          vitamin: {
            a: 0,
            c: 0,
            calcium: 4,
            iron: 6
          }
        },
        ingredients:
          "Soybean oil, distilled white vinegar, water, romano cheese made from cow's milk (cultured milk, salt, enzymes), egg yolks, sugar, parmesan cheese (cultured milk, salt, enzymes), extra virgin olive oil, dried garlic, salt, whey protein concentrate, lemon juice concentrate, dried onion, flavor (water, cream [from milk], salt, butterfat, natural flavor, xanthan gum), romano cheese type flavor concentrate (romano cheese made from cow's milk and cheddar chese [pasteurized milk, cheese culture, salt, enzymes], water, salt, disodium phosphate, enzymes), xanthan gum, black pepper, potassium sorbate, sodium benzoate (to preserve quality), worcestershire sauce (distilled white vinegar, molasses, sugar, water, salt, onions, anchovies, garlic, cloves, tamarind extract, natural flavorings, chili pepper extract), calcium disodium edta (to preserve quality)",
        allergy: "Milk, Egg, Soy, Fish (Anchovies)."
      },
      {
        id: "greekFeta",
        name: "Greek Feta Herb Vinaigrette",
        description:
          "Packed with Mediterranean-inspired flavors and bits of real feta cheese, this creamy vinaigrette is the perfect match for any Greek salad.",
        image: {
          small: "/img/products/small/greekFeta.jpg",
          full: "/img/products/full/greekFeta.png"
        },
        recipes: ["greekFetaSalad", "saladPenne"], //list of paired recipes
        nutrition: {
          servings: 12,
          servingSize: {
            tbps: 2,
            g: 31
          },
          calories: {
            base: 70,
            fat: 60
          },
          fat: {
            total: {
              percent: 11,
              g: 7
            },
            sat: {
              percent: 5,
              g: 1
            },
            trans: {
              g: 0
            }
          },
          cholesterol: {
            percent: 2,
            mg: 5
          },
          sodium: {
            percent: 17,
            mg: 410
          },
          carbs: {
            total: {
              percent: 1,
              g: 3
            },
            fiber: {
              percent: 0,
              g: 0
            },
            sugar: {
              g: 2
            }
          },
          protein: {
            g: 0
          },
          vitamin: {
            a: 0,
            c: 0,
            calcium: 2,
            iron: 0
          }
        },
        ingredients:
          "Water, distilled white vinegar, soybean oil, sugar, feta cheese (modified milk ingredients, salt, calcium chloride, microbial enzymes, lactic acid, bacterial cultures, powdered cellulose, natamycin), red wine vinegar, salt, extra virgin olive oil, dried garlic, cucumber juice, dried onion, spices, modified cornstarch, egg yolks, lemon juice concentrate, xanthan gum, potassium sorbate (to preserve freshness), sodium benzoate and calcium disodium edta (to preserve freshness).",
        allergy: "Milk, Egg."
      },
      {
        id: "cubanCitrus",
        name: "Cuban Style Orange Citrus",
        description:
          "Packed with bright, fruity flavors from real orange zest, this vinaigrette makes a great marinade to turn your entrée into a Cuban style dish.",
        image: {
          small: "/img/products/small/cubanCitrus.jpg",
          full: "/img/products/full/cubanCitrus.png"
        },
        useSameBackgrounds: true,
        recipes: ["grilledMahiMahi", "avocadoToastSalad"], //list of paired recipes
        nutrition: {
          servings: 12,
          servingSize: {
            tbps: 2,
            g: 32
          },
          calories: {
            base: 45,
            fat: 25
          },
          fat: {
            total: {
              percent: 4,
              g: 2.5
            },
            sat: {
              percent: 0,
              g: 0
            },
            trans: {
              g: 0
            }
          },
          cholesterol: {
            percent: 0,
            mg: 0
          },
          sodium: {
            percent: 11,
            mg: 260
          },
          carbs: {
            total: {
              percent: 2,
              g: 5
            },
            fiber: {
              percent: 0,
              g: 0
            },
            sugar: {
              g: 3
            }
          },
          protein: {
            g: 0
          },
          vitamin: {
            a: 0,
            c: 0,
            calcium: 10,
            iron: 0
          }
        },
        ingredients:
          "Water, distilled white vinegar, extra virgin olive oil, sugar, orange juice concentrate, orange peel, salt, garlic, green bell pepper, lime juice concentrate, lemon juice concentrate, onion, spices, modified corn starch, xanthan gum, potassium sorbate (to preserve quality), natural flavors, and calcium disodium edta (to preserve quality)."
      },
      {
        id: "cilantroLime",
        name: "Mexican Style Cilantro Lime",
        description:
          "This vinaigrette is packed with bright cilantro and lime flavors.  It’s the perfect addition to any burrito bowl or taco salad.",
        image: {
          small: "/img/products/small/cilantroLime.jpg",
          full: "/img/products/full/cilantroLime.png"
        },
        recipes: ["chickenTacos", "chickenSandwich"], //list of paired recipes
        nutrition: {
          servings: 12,
          servingSize: {
            tbps: 2,
            g: 32
          },
          calories: {
            base: 35,
            fat: 25
          },
          fat: {
            total: {
              percent: 4,
              g: 2.5
            },
            sat: {
              percent: 0,
              g: 0
            },
            trans: {
              g: 0
            }
          },
          cholesterol: {
            percent: 0,
            mg: 0
          },
          sodium: {
            percent: 11,
            mg: 260
          },
          carbs: {
            total: {
              percent: 1,
              g: 3
            },
            fiber: {
              percent: 0,
              g: 0
            },
            sugar: {
              g: 2
            }
          },
          protein: {
            g: 0
          },
          vitamin: {
            a: 8,
            c: 10,
            calcium: 0,
            iron: 2
          }
        },
        ingredients:
          "Water, distilled white vinegar, extra virgin olive oil, lime juice concentrate, sugar, salt, red bell pepper, garlic, onion, spices, modified food starch, ancho chili pepper, xanthan gum, paprika, cilantro, natural jalapeno type flavor, natural lime flavor, natural flavor, potassium sorbate and calcium disodium edta (to protect quality)."
      },
      {
        id: "mangoChipotle",
        name: "Mexican Style Mango Chipotle ",
        description:
          "With bold chipotle flavors and real mango puree, this vinaigrette is the perfect blend of sweet and smoky with a kick.",
        image: {
          small: "/img/products/small/mangoChipotle.jpg",
          full: "/img/products/full/mangoChipotle.png"
        },
        recipes: ["chickenTacoSalad", "quinoaBowl"], //list of paired recipes
        nutrition: {
          servings: 12,
          servingSize: {
            tbps: 2,
            g: 32
          },
          calories: {
            base: 25,
            fat: 0
          },
          fat: {
            total: {
              percent: 1,
              g: 0.5
            },
            sat: {
              percent: 0,
              g: 0
            },
            trans: {
              g: 0
            }
          },
          cholesterol: {
            percent: 0,
            mg: 0
          },
          sodium: {
            percent: 11,
            mg: 270
          },
          carbs: {
            total: {
              percent: 2,
              g: 5
            },
            fiber: {
              percent: 0,
              g: 0
            },
            sugar: {
              g: 4
            }
          },
          protein: {
            g: 0
          },
          vitamin: {
            a: 4,
            c: 10,
            calcium: 0,
            iron: 0
          }
        },
        ingredients:
          "Water, distilled white vinegar, sugar, mangoes, pineapple juice concentrate, apple cider vinegar, salt, extra virgin olive oil, garlic, chipotle pepper, lemon juice concentrate, onion, red bell pepper, modified corn starch, xanthan gum, citric acid, spices, natural flavor, paprika, potassium sorbate and calcium disodium edta (to preserve quality)."
      },
      {
        id: "sesameGinger",
        name: "Asian Style Sesame Ginger",
        description:
          "This sweet and tangy dressing is packed with real ginger and whole sesame seeds.  It’s the perfect complement to any Asian style salad.",
        image: {
          small: "/img/products/small/sesameGinger.jpg",
          full: "/img/products/full/sesameGinger.png"
        },
        recipes: ["kaleAppleSalad", "shrimpRolls"], //list of paired recipes
        nutrition: {
          servings: 12,
          servingSize: {
            tbps: 2,
            g: 33
          },
          calories: {
            base: 50,
            fat: 15
          },
          fat: {
            total: {
              percent: 2,
              g: 1.5
            },
            sat: {
              percent: 0,
              g: 0
            },
            trans: {
              g: 0
            }
          },
          cholesterol: {
            percent: 0,
            mg: 0
          },
          sodium: {
            percent: 11,
            mg: 270
          },
          carbs: {
            total: {
              percent: 3,
              g: 8
            },
            fiber: {
              percent: 0,
              g: 0
            },
            sugar: {
              g: 7
            }
          },
          protein: {
            g: 0
          },
          vitamin: {
            a: 0,
            c: 2,
            calcium: 0,
            iron: 0
          }
        },
        ingredients:
          "Water, distilled white vinegar, sugar, soy sauce (water, soybeans, wheat, salt), extra virgin olive oil, orange juice concentrate, orange peel, garlic, ginger puree (ginger, water), toasted sesame seeds, onion juice concenrate, roasted sesame seed oil, xanthan gum, onion, spice, red pepper flakes, potassium sorbate and calcium disodium edta (to preserve quality)",
        allergy: "Soy, Wheat, Sesame Seed."
      }
    ]
  },
  sauces: {
    title: "Cooking Sauces",
    intro:
      "Add a twist on the familiar by adding Food Network Kitchen<sup>TM</sup> inspired sauces to your meal.",
    header: {
      left: "sauces_left.png",
      right: "sauces_right.png"
    },
    items: [
        {
        id: "teriyaki",
        name: "Japanese Style Teriyaki",
        description:
          "This sweet sauce is packed with real ginger and sesame seeds.  It’s the perfect complement to any Asian style meal.",
        image: {
          small: "/img/products/small/teriyaki.jpg",
          full: "/img/products/full/teriyaki.png"
        },
        recipes: ["teriyakiSalmon", "teriyakiChicken"], //list of paired recipes
        nutrition: {
          servings: 25,
          servingSize: {
            tbps: 1,
            g: 17
          },
          calories: {
            base: 20,
            fat: 0
          },
          fat: {
            total: {
              percent: 0,
              g: 0
            },
            sat: {
              percent: 0,
              g: 0
            },
            trans: {
              g: 0
            }
          },
          cholesterol: {
            percent: 0,
            mg: 0
          },
          sodium: {
            percent: 8,
            mg: 200
          },
          carbs: {
            total: {
              percent: 1,
              g: 4
            },
            fiber: {
              percent: 0,
              g: 0
            },
            sugar: {
              g: 4
            }
          },
          protein: {
            g: 0
          },
          vitamin: {
            a: 0,
            c: 0,
            calcium: 0,
            iron: 0
          }
        },
        ingredients:
          "Distilled white vinegar, soy sauce (water, soybeans, wheat, salt), sugar, water, corn starch, garlic, onion juice concentrate, garlic, onion, orange peel, toasted sesame seeds, ginger, toasted sesame oil, red pepper flakes.",
        allergy: "Soy, Wheat, Sesame Seed."
      },
        {
        id: "jerk",
        name: "Jamaican Style Jerk",
        description:
          "With bold Jamaican flavors and spices, this cooking sauce will transform your ordinary meal into a trip to the Caribbean.",
        image: {
          small: "/img/products/small/jerk.jpg",
          full: "/img/products/full/jerk.png"
        },
        recipes: ["jerkPulledPork", "jerkChicken"], //list of paired recipes
        nutrition: {
          servings: 17,
          servingSize: {
            tbps: 1,
            g: 25
          },
          calories: {
            base: 25,
            fat: 0
          },
          fat: {
            total: {
              percent: 0,
              g: 0
            },
            sat: {
              percent: 0,
              g: 0
            },
            trans: {
              g: 0
            }
          },
          cholesterol: {
            percent: 0,
            mg: 0
          },
          sodium: {
            percent: 10,
            mg: 250
          },
          carbs: {
            total: {
              percent: 2,
              g: 5
            },
            fiber: {
              percent: 0,
              g: 0
            },
            sugar: {
              g: 4
            }
          },
          protein: {
            g: 0
          },
          vitamin: {
            a: 2,
            c: 2,
            calcium: 0,
            iron: 2
          }
        },
        ingredients:
          "Tomato puree (water, tomato paste), distilled white vinegar, sugar, dark brown sugar, molasses, salt, pineapple juice concentrate, corn starch, dried garlic, garlic, onion juice concentrate, spices, dried onion, natural flavor, citric acid, capsicum oleoresin."
      },
        {
            id: "sweetSpicyChili",
            name: "Thai Style Sweet & Spicy Chili",
            description:
                "This sweet and spicy cooking sauce is the perfect way to add excitement to your meat, chicken or shrimp.",
            image: {
                small: "/img/products/small/sweetSpicyChili.jpg",
                full: "/img/products/full/sweetSpicyChili.png"
            },
            useSameBackgrounds: true,
            recipes: ["thaiRibs", "thaiShrimp"], //list of paired recipes
            nutrition: {
                servings: 25,
                servingSize: {
                    tbps: 1,
                    g: 17
                },
                calories: {
                    base: 20,
                    fat: 0
                },
                fat: {
                    total: {
                        percent: 0,
                        g: 0
                    },
                    sat: {
                        percent: 0,
                        g: 0
                    },
                    trans: {
                        g: 0
                    }
                },
                cholesterol: {
                    percent: 0,
                    mg: 0
                },
                sodium: {
                    percent: 9,
                    mg: 220
                },
                carbs: {
                    total: {
                        percent: 2,
                        g: 5
                    },
                    fiber: {
                        percent: 0,
                        g: 0
                    },
                    sugar: {
                        g: 4
                    }
                },
                protein: {
                    g: 0
                },
                vitamin: {
                    a: 2,
                    c: 2,
                    calcium: 0,
                    iron: 0
                }
            },
            ingredients:
                "Distilled white vinegar, tomato puree (water, tomato paste), sugar, soy sauce (water, wheat, soybeans, salt), garlic, corn starch, dried garlic, salt, cayenne pepper, dried red pepper, red pepper flakes, paprika oleoresin.",
            allergy: "Wheat, Soy."
        },
        {
            id: "adobo",
            name: "Mexican Style Adobo Cooking Sauce ",
            description:
                "This flavorful cooking sauce takes your palette on a trip to Mexico—sweet, tangy with a touch of heat.",
            image: {
                small: "/img/products/small/adobo.jpg",
                full: "/img/products/full/adobo.png"
            },
            useSameBackgrounds: false,
            recipes: [], //list of paired recipes
            nutrition: {
                servings: 25,
                servingSize: {
                    tbps: 1,
                    g: 17
                },
                calories: {
                    base: 10,
                    fat: 0
                },
                fat: {
                    total: {
                        percent: 0,
                        g: 0
                    },
                    sat: {
                        percent: 0,
                        g: 0
                    },
                    trans: {
                        g: 0
                    }
                },
                cholesterol: {
                    percent: 0,
                    mg: 0
                },
                sodium: {
                    percent: 6,
                    mg: 140
                },
                carbs: {
                    total: {
                        percent: 1,
                        g: 2
                    },
                    fiber: {
                        percent: 1,
                        g: 0
                    },
                    sugar: {
                        g: 1
                    }
                },
                protein: {
                    g: 0
                },
                vitamin: {
                    d: 0,
                    calcium: 0,
                    iron: 0,
                    potassium: 0
                }
            },
            ingredients:
                "Tomato Puree (Tomato Paste, Water), Distilled White Vinegar, Water, Sugar, Salt, Pineapple Juice Concentrate, Red Bell Pepper*, Ancho Chili Pepper*, Paprika*, Modified Food Starch, Cumin*, Tamarind Extract, Molasses, Onion*, Cayenne Peppers*, Garlic*, Oregano*, Lime Juice Concentrate, Roasted Poblano Pepper Puree (Poblano Peppers, Water, Citric Acid), Natural Smoke Flavor, Spices, Chipotle Puree (Chipotle Peppers, Citric Acid), Poblano Peppers*, Natural Flavor. *dried",
            allergy: "No Allergens (can exclude) "
        },
        {
          id: "tuscanHerb",
          name: "Tuscan Style Herb & Balsamic",
          description:
            "Packed with Tuscan-inspired flavors and fresh herbs, this cooking sauce is delicious with fish and light flavored meats, such as chicken or pork.",
          image: {
            small: "/img/products/small/tuscanHerb.jpg",
            full: "/img/products/full/tuscanHerb.png"
          },
          recipes: ["grilledPork", "chickenRavioli"], //list of paired recipes
          nutrition: {
            servings: 14,
            servingSize: {
              tbps: 2,
              g: 30
            },
            calories: {
              base: 40,
              fat: 30
            },
            fat: {
              total: {
                percent: 5,
                g: 3.5
              },
              sat: {
                percent: 5,
                g: 1
              },
              trans: {
                g: 0
              }
            },
            cholesterol: {
              percent: 2,
              mg: 5
            },
            sodium: {
              percent: 9,
              mg: 210
            },
            carbs: {
              total: {
                percent: 0,
                g: 1
              },
              fiber: {
                percent: 0,
                g: 0
              },
              sugar: {
                g: 1
              }
            },
            protein: {
              g: 1
            },
            vitamin: {
              a: 2,
              c: 2,
              calcium: 2,
              iron: 2
            }
          },
          ingredients:
            "Tomato puree (water, tomato paste), water, balsamic vinegar, sugar, salt, onion juice concentrate, butter (cream, salt), garlic, corn starch, spices, dried onion, citric acid, natural flavor",
          allergy: "Milk."
        },
        {
          id: "gochujang",
          name: "Korean Gochujang",
          description:
            "Packed with savory, sweet and spicy flavors, this cooking sauce can turn your average meal into an exciting Korean masterpiece.",
          image: {
            small: "/img/products/small/gochujang.jpg",
            full: "/img/products/full/gochujang.png"
          },
          recipes: ["flankSteak", "riceBowls"], //list of paired recipes
          nutrition: {
            servings: 25,
            servingSize: {
              tbps: 1,
              g: 17
            },
            calories: {
              base: 30,
              fat: 0
            },
            fat: {
              total: {
                percent: 0,
                g: 0
              },
              sat: {
                percent: 0,
                g: 0
              },
              trans: {
                g: 0
              }
            },
            cholesterol: {
              percent: 0,
              mg: 0
            },
            sodium: {
              percent: 13,
              mg: 310
            },
            carbs: {
              total: {
                percent: 2,
                g: 7
              },
              fiber: {
                percent: 0,
                g: 0
              },
              sugar: {
                g: 5
              }
            },
            protein: {
              g: 1
            },
            vitamin: {
              a: 0,
              c: 0,
              calcium: 0,
              iron: 2
            }
          },
          ingredients:
            "Water, gochujang (wheat flour, rice syrup, water, red pepper powder, salt, wheat, defatted soybean powder, cooking rice wine, koji), dark brown sugar, rice wine vinegar, soy sauce (water, soybeans, wheat, salt), sugar, rice cooking wine, miso paste, (water, organic soybeans, rice, sea salt, koji), corn starch, onion juice concentrate, citric acid, garlic, onion, red pepper, salt, xanthan gum.",
          allergy: "Wheat, Soy"
        }
    ]
  },
  mealKits: {
    title: "Meal Kits",
    intro:
      "Create flavorful, Food Network Kitchen<sup>TM</sup> inspired meals without all the hard work.",
    header: {
      left: "mealKits_left.png",
      right: "mealKits_right.png"
    },
    items: [
        {
            id: "padThai",
            name: "Chicken Pad Thai kit",
            description:
                "Sweet and tangy flavors pair with chicken for a satisfying take on the Thai noodle dish.",
            image: {
                top: "/img/mealkitImg/chickenPadThaiTop.jpg",
                bottom: "/img/mealkitImg/chickenPadThaiBottom.jpg",
                small: "/img/products/small/padThai.jpg",
                full: "/img/products/full/padThai.png"
            },
            hideHeaderLeft: true,
            contents: [
                {
                    title: "Vegetable Blend",
                    content: "Carrots, Red Bell Peppers, Onions"
                },
                {
                    title: "Pad Thai Sauce"
                },
                {
                    title: "Rice Noodle"
                }
            ],
            purchase: [
                "2 Tbsp. oil",
                "1 lb boneless, skinless chicken breasts",
                "2 Eggs",
                "1 Lime (optional)",
                "1 Bunch Cilantro (optional)"
            ],
            nutrition: {
                servings: 5,
                servingSize: {
                    oz: 2.5,
                    g: 70
                },
                showPrepared: true,
                calories: {
                    base: 160,
                    basePrep: 340,
                    fat: 20,
                    fatPrep: 110
                },
                fat: {
                    total: {
                        percent: 3,
                        percentPrep: 18,
                        g: 2
                    },
                    sat: {
                        percent: 0,
                        percentPrep: 13,
                        g: 0
                    },
                    trans: {
                        g: 0
                    }
                },
                cholesterol: {
                    percent: 0,
                    percentPrep: 43,
                    mg: 0
                },
                sodium: {
                    percent: 15,
                    percentPrep: 18,
                    mg: 360
                },
                carbs: {
                    total: {
                        percent: 11,
                        percentPrep: 11,
                        g: 33
                    },
                    fiber: {
                        percent: 8,
                        percentPrep: 8,
                        g: 2
                    },
                    sugar: {
                        g: 7
                    }
                },
                protein: {
                    g: 3
                },
                vitamin: {
                    a: 50,
                    aPrep: 60,
                    c: 50,
                    cPrep: 50,
                    calcium: 2,
                    calciumPrep: 4,
                    iron: 4,
                    ironPrep: 10
                }
            },
            ingredients:
                "Pad thai sauce (Water, soy sauce [water, wheat, soybeans, salt], sugar, rice vinegar, onion, garlic puree, tomato paste, canola oil, modified corn starch, lime juice concentrate, coriander, crushed red pepper, natural flavor, xanthan gum), rice noodles (rice flour, potato starch, tapioca starch), vegetable blend (carrot, onion, red bell pepper)",
            allergy: "Wheat, Soy."
        },
        {
        id: "chickenPestoFlatBread",
        name: "Chicken Pesto Flatbread Kit",
        description:
          "This bright and garlicky Italian style pesto tops this soft and tender crust for an amazing meal.",
        image: {
          top: "/img/mealkitImg/chickenPestoTop.jpg",
          bottom: "/img/mealkitImg/chickenPestoBottom.jpg",
          small: "/img/products/small/chickenPestoFlatBread.jpg",
          full: "/img/products/full/chickenPestoFlatBread.png"
        },
        hideHeaderLeft: true,
        contents: [
          {
            title: "Parmesan Cheese"
          },
          {
            title: "Basil Pesto Sauce"
          },
          {
            title: "Flatbread Crust Mix"
          }
        ],
        purchase: [
          "1 Tbsp. Olive Oil",
          "1 Cooked Chicken Breast (4 oz.)",
          "3/4 cup Warm Water",
          "1 cup Shredded Mozzarella Cheese",
          "1/2 cup Cherry Tomatoes"
        ],
        nutrition: {
          servings: 2.5,
          servingSize: {
            oz: 2.5,
            g: 70
          },
          showPrepared: true,
          calories: {
            base: 240,
            basePrep: 350,
            fat: 20,
            fatPrep: 110
          },
          fat: {
            total: {
              percent: 3,
              percentPrep: 18,
              g: 2
            },
            sat: {
              percent: 5,
              percentPrep: 35,
              g: 1
            },
            trans: {
              g: 0
            }
          },
          cholesterol: {
            percent: 2,
            percentPrep: 10,
            mg: 5
          },
          sodium: {
            percent: 13,
            percentPrep: 49,
            mg: 320
          },
          carbs: {
            total: {
              percent: 17,
              percentPrep: 18,
              g: 51
            },
            fiber: {
              percent: 12,
              percentPrep: 16,
              g: 3
            },
            sugar: {
              g: 2
            }
          },
          protein: {
            g: 7
          },
          vitamin: {
            a: 0,
            aPrep: 15,
            c: 8,
            cPrep: 15,
            calcium: 6,
            calciumPrep: 8,
            iron: 10,
            ironPrep: 10
          }
        },
        ingredients:
          "Flatbread Crust Mix (Enriched Wheat Flour [wheat Flour, Niacin, Reduced Iron, Thiamin Mononitrate (Vitamin B1), Riboflavin (Vitamin B2), Folic Acid], Yeast, Salt, Sodium Aluminum Phosphate, Soybean Oil, Sugar, Sodium Bicarbonate, Ascorbic Acid, Calcium Phosphate), Pesto Sauce (Basil, Soybean Oil, Garlic, Parmesan Cheese Powder [Pasteurized Milk Solids, Whey Solids, Salt, Buttermilk Solids, Natural Flavor, Lactic Acid, Cultures, Enzymes], Extra Virgin Olive Oil, Salt, Lactic Acid, Oregano, Natural Flavor), Parmesan Cheese ([Pasteurized Part-skim Milk, Cheese Culture, Salt, Enzymes], Cellulose Powder Added To Prevent Caking, Potassium Sorbate To Protect Flavor).",
        allergy: "Wheat, MILK."
      },
        {
            id: "shrimpScampi",
            name: "Shrimp Scampi kit",
            description:
                "Lemony shrimp are tossed with linguine pasta, herbs and Parmesan cheese.",
            image: {
                top: "/img/mealkitImg/shrimpScampiTop.jpg",
                bottom: "/img/mealkitImg/shrimpScampiBottom.jpg",
                small: "/img/products/small/shrimpScampi.jpg",
                full: "/img/products/full/shrimpScampi.png"
            },
            videoURL: "/videos/Shrimp_Scampi.mp4",
            hideHeaderLeft: true,
            contents: [
                {
                    title: "Onions"
                },
                {
                    title: "Parmesan Cheese"
                },
                {
                    title: "Herb Seasoning"
                },
                {
                    title: "Linguine Pasta"
                }
            ],
            purchase: [
                "2 Tbsp. butter",
                "1 1/4 cups water",
                "1/2 lb uncooked medium shrimp",
                "1 lemon",
                "1 bunch parsley (optional)"
            ],
            nutrition: {
                servings: 2.5,
                servingSize: {
                    oz: 1.5,
                    g: 42
                },
                showPrepared: true,
                calories: {
                    base: 150,
                    basePrep: 320,
                    fat: 15,
                    fatPrep: 110
                },
                fat: {
                    total: {
                        percent: 2,
                        percentPrep: 18,
                        g: 1.5
                    },
                    sat: {
                        percent: 5,
                        percentPrep: 35,
                        g: 1
                    },
                    trans: {
                        g: 0
                    }
                },
                cholesterol: {
                    percent: 2,
                    percentPrep: 58,
                    mg: 5
                },
                sodium: {
                    percent: 13,
                    percentPrep: 40,
                    mg: 300
                },
                carbs: {
                    total: {
                        percent: 9,
                        percentPrep: 10,
                        g: 28
                    },
                    fiber: {
                        percent: 8,
                        percentPrep: 8,
                        g: 2
                    },
                    sugar: {
                        g: 3
                    }
                },
                protein: {
                    g: 6
                },
                vitamin: {
                    a: 0,
                    aPrep: 10,
                    c: 4,
                    cPrep: 4,
                    calcium: 6,
                    calciumPrep: 15,
                    iron: 6,
                    ironPrep: 8
                }
            },
            ingredients:
                "Enriched macaroni product (semolina [wheat], niacin, ferrous sulfate [iron], thiamin mononitrate, riboflavin, folic acid), parmesan chesse ([pasteurized part-skim milk, cheese culture, salt, enzymes], cellulose powder to prevent caking, potassium sorbate to protect flavor), dried onion, seasoning blend (dried garlic, sugar, salt, sodium citrate, spices, sunflower oil).",
            allergy: "Wheat, Milk."
        },
        {
            id: "tikkaMasala",
            name: "Chicken Tikka Masala kit",
            description:
                "Rice, vegetables, chicken and a spicy tomato cream sauce create a savory Indian-inspired meal.",
            image: {
                top: "/img/mealkitImg/chickenTikkaMasalaIngredientsTop.jpg",
                bottom: "/img/mealkitImg/chickenTikkaMasalaIngredientsBottom.jpg",
                small: "/img/products/small/tikkaMasala.jpg",
                full: "/img/products/full/tikkaMasala.png"
            },
            videoURL: "/videos/Tikka_Masala.mp4",
            hideHeaderLeft: true,
            contents: [
                {
                    title: "Vegetable Blend",
                    content: "Carrots, Chickpeas, Onions"
                },
                {
                    title: "Tikka Masala Sauce"
                },
                {
                    title: "Rice"
                }
            ],
            purchase: [
                "1 tsp. oil",
                "1 1/3 cups water",
                "1/2 lb boneless, skinless chicken thighs",
                "1 bunch cilantro (optional)",
                "2 Tbsp. Plain Greek-style Yogurt (optional)"
            ],
            nutrition: {
                servings: 2.5,
                servingSize: {
                    oz: 3,
                    g: 84
                },
                showPrepared: true,
                calories: {
                    base: 200,
                    basePrep: 330,
                    fat: 5,
                    fatPrep: 70
                },
                fat: {
                    total: {
                        percent: 1,
                        percentPrep: 12,
                        g: 0.5
                    },
                    sat: {
                        percent: 0,
                        percentPrep: 10,
                        g: 0
                    },
                    trans: {
                        g: 0
                    }
                },
                cholesterol: {
                    percent: 0,
                    percentPrep: 28,
                    mg: 0
                },
                sodium: {
                    percent: 19,
                    percentPrep: 22,
                    mg: 460
                },
                carbs: {
                    total: {
                        percent: 15,
                        percentPrep: 15,
                        g: 44
                    },
                    fiber: {
                        percent: 15,
                        percentPrep: 15,
                        g: 4
                    },
                    sugar: {
                        g: 9
                    }
                },
                protein: {
                    g: 5
                },
                vitamin: {
                    a: 70,
                    aPrep: 70,
                    c: 15,
                    cPrep: 15,
                    calcium: 6,
                    calciumPrep: 8,
                    iron: 10,
                    ironPrep: 15
                }
            },
            ingredients:
                "Tikka masala sauce (water, tomato paste, sugar, distilled vinegar, salt, onion, nonfat yogurt [cultured nonfat milk], cumin, modified corn starch, natural flavors, garlic powder, coriander, ginger, tumeric, black pepper, red pepper, cloves, cinnamon, cardamon, fenugreek, bay leaves), enriched parboiled long grain rice (long grain parboiled rice, iron [ferric orthophosphate], niacin, thiamin [thiamin mononitrate], folic acid), vegetable blend (chickpeas, carrots, onions).",
            allergy: "Milk."
        },
        {
            id: "chickenRice",
            name: "Spicy Szechuan-style Chicken & Rice kit",
            description:
                "Bold Szechuan flavors combine with hearty chicken, vegetables and rice.",
            image: {
                top: "/img/mealkitImg/spicySzechuanStyleTop.jpg",
                bottom: "/img/mealkitImg/spicySzechuanStyleBottom.jpg",
                small: "/img/products/small/chickenRice.jpg",
                full: "/img/products/full/chickenRice.png"
            },
            hideHeaderLeft: true,
            contents: [
                {
                    title: "Vegetable Blend",
                    content: "Carrots, Red Peppers, Green Beans"
                },
                {
                    title: "Szechuan-Style Sauce"
                },
                {
                    title: "Rice"
                }
            ],
            purchase: [
                "1 tsp. oil",
                "1 1/4 cups water",
                "1/2 lb boneless, skinless chicken thighs",
                "1 bunch green onions (optional)"
            ],
            nutrition: {
                servings: 2.5,
                servingSize: {
                    oz: 2.5,
                    g: 70
                },
                showPrepared: true,
                calories: {
                    base: 200,
                    basePrep: 360,
                    fat: 0,
                    fatPrep: 100
                },
                fat: {
                    total: {
                        percent: 0,
                        percentPrep: 17,
                        g: 0
                    },
                    sat: {
                        percent: 0,
                        percentPrep: 13,
                        g: 0
                    },
                    trans: {
                        g: 0
                    }
                },
                cholesterol: {
                    percent: 0,
                    percentPrep: 28,
                    mg: 0
                },
                sodium: {
                    percent: 12,
                    percentPrep: 15,
                    mg: 290
                },
                carbs: {
                    total: {
                        percent: 14,
                        percentPrep: 14,
                        g: 43
                    },
                    fiber: {
                        percent: 12,
                        percentPrep: 12,
                        g: 3
                    },
                    sugar: {
                        g: 8
                    }
                },
                protein: {
                    g: 4
                },
                vitamin: {
                    a: 90,
                    aPrep: 90,
                    c: 45,
                    cPrep: 45,
                    calcium: 6,
                    calciumPrep: 6,
                    iron: 10,
                    ironPrep: 15
                }
            },
            ingredients:
                "Enriched parboiled long grain rice (long grain parboiled rice, iron [ferric orthophosphate], niacin, thiamin [thiamin mononitrate], folic acid), szechuan style sauce (Water, soy sauce [water, wheat, soybeans, salt], sugar, distilled vingegar, modified foodstarch, red pepper, garlic, onion, onion powder, orange peel, toasted sesame oil, ginger, garlic powder), vegetable blend (carrots, green beans, red bell peppers).",
            allergy: "Wheat, Soy, Sesame."
        },
        {
            id: "southwestChicken",
            name: "Southwest-Style Chicken & Rice Kit",
            description:
                "This light smoky and spicy rice and vegetable bowl is the perfect meal with chicken.",
            image: {
                top: "/img/mealkitImg/swChickenTop.jpg",
                bottom: "/img/mealkitImg/swChickenBottom.jpg",
                small: "/img/products/small/southwestChicken.jpg",
                full: "/img/products/full/southwestChicken.png"
            },
            hideHeaderLeft: true,
            contents: [
                {
                    title: "Bean & Vegetable Blend",
                    content: "Dried: Black Beans, Corn, Red Bell Peppers, Onions"
                },
                {
                    title: "White Rice"
                },
                {
                    title: "Chipotle Sauce"
                }
            ],
            purchase: [
                "1 tsp. Oil",
                "1/2 lb. Chicken",
                "1-1/2 cups Water",
                "1 bunch Cilantro",
                "1 Avocado",
            ],
            nutrition: {
                servings: 2.5,
                servingSize: {
                    oz: 2.5,
                    g: 70
                },
                showPrepared: true,
                calories: {
                    base: 180,
                    basePrep: 300,
                    fat: 0,
                    fatPrep: 100
                },
                fat: {
                    total: {
                        percent: 2,
                        percentPrep: 9,
                        g: 0
                    },
                    sat: {
                        percent: 0,
                        percentPrep: 7,
                        g: 1.5
                    },
                    trans: {
                        g: 0
                    }
                },
                cholesterol: {
                    percent: 0,
                    percentPrep: 23,
                    mg: 70
                },
                sodium: {
                    percent: 18,
                    percentPrep: 20,
                    mg: 410
                },
                carbs: {
                    total: {
                        percent: 13,
                        percentPrep: 13,
                        g: 35
                    },
                    fiber: {
                        percent: 13,
                        percentPrep: 12,
                        g: 4
                    },
                    sugar: {
                        g: 5
                    }
                },
                protein: {
                    g: 5
                },
                vitamin: {
                    d: 0,
                    dPrep: 0,
                    calcium: 4,
                    calciumPrep: 4,
                    iron: 10,
                    ironPrep: 15,
                    potassium: 6,
                    potassiumPrep: 10,
                }
            },
            ingredients:
                "Chipotle Sauce (Water, Tomato Paste, Chipotle Puree [Water, Distilled White Vinegar, Chipotle Jalapeno Peppers, Tomato Paste, Salt, Red Chile*, Spices, Onion Powder, Garlic Powder], Soybean Oil, Salt, Sugar, Chili Peppers, Roasted Garlic*, Garlic Powder, Onion Powder, Cumin, Citric Acid, Natural Flavor, Oregano), Enriched Parboiled Long Grain Rice (Long Grain Parboiled Rice, Iron [Ferric Orthophosphate], Niacin, Thiamin [Thiamin Mononitrate], Folic Acid), Bean And Vegetable Blend (Black Beans*, Corn*, Red Bell Peppers*, Onions*). *Dried.",
            allergy: "No Allergens (can exclude)."
        },
        {
            id: "koreanBBQ",
            name: "Korean-Style BBQ Kit",
            description:
                "Delicious steak is tossed with a sweet and spicy BBQ served with kimchi and rice.",
            image: {
                top: "/img/mealkitImg/koreanBbqTop.jpg",
                bottom: "/img/mealkitImg/koreanBbqBottom.jpg",
                small: "/img/products/small/KoreanBBQ.jpg",
                full: "/img/products/full/KoreanBBQ.png"
            },
            hideHeaderLeft: true,
            contents: [
                {
                    title: "Rice",
                },
                {
                    title: "Kimchi-Style Sauce",
                },
                {
                    title: "Dried Cabbage",
                },
                {
                    title: "Korean-Style BBQ Sauce",
                },
            ],
            purchase: [
                "1 tsp. Oil",
                "1/2 lb. Skirt Steak",
                "1-1/2 cups Water",
                "Sliced Green Onions (optional)",
                "Toasted Sesame Seeds (optional)",
            ],
            nutrition: {
                servings: 2.5,
                servingSize: {
                    oz: 2.5,
                    g: 70
                },
                showPrepared: true,
                calories: {
                    base: 200,
                    basePrep: 360,
                    fat: 0,
                    fatPrep: 100
                },
                fat: {
                    total: {
                        percent: 0,
                        percentPrep: 17,
                        g: 0
                    },
                    sat: {
                        percent: 0,
                        percentPrep: 13,
                        g: 0
                    },
                    trans: {
                        g: 0
                    }
                },
                cholesterol: {
                    percent: 0,
                    percentPrep: 28,
                    mg: 0
                },
                sodium: {
                    percent: 12,
                    percentPrep: 15,
                    mg: 290
                },
                carbs: {
                    total: {
                        percent: 14,
                        percentPrep: 14,
                        g: 43
                    },
                    fiber: {
                        percent: 12,
                        percentPrep: 12,
                        g: 3
                    },
                    sugar: {
                        g: 8
                    }
                },
                protein: {
                    g: 4
                },
                vitamin: {
                    a: 90,
                    aPrep: 90,
                    c: 45,
                    cPrep: 45,
                    calcium: 6,
                    calciumPrep: 6,
                    iron: 10,
                    ironPrep: 15
                }
            },
            ingredients:
                "Enriched parboiled long grain rice (long grain parboiled rice, iron [ferric orthophosphate], niacin, thiamin [thiamin mononitrate], folic acid), szechuan style sauce (Water, soy sauce [water, wheat, soybeans, salt], sugar, distilled vingegar, modified foodstarch, red pepper, garlic, onion, onion powder, orange peel, toasted sesame oil, ginger, garlic powder), vegetable blend (carrots, green beans, red bell peppers).",
            allergy: "Wheat, Soy, Sesame."
        },
        {
        id: "mushroomRisotto",
        name: "Tuscan-style Mushroom Risotto kit",
        description:
          "A savory Italian meal that combines creamy rice, mushrooms, peas and herbs.",
        image: {
          top: "/img/mealkitImg/tuscanMushroomTop.jpg",
          bottom: "/img/mealkitImg/tuscanMushroomBottom.jpg",
          small: "/img/products/small/mushroomRisotto.jpg",
          full: "/img/products/full/mushroomRisotto.png"
        },
        hideHeaderLeft: true,
        contents: [
          {
            title: "Mushroom & Onion Blend"
          },
          {
            title: "Herb Seasoning"
          },
          {
            title: "Arborio Rice"
          },
          {
            title: "Parmesan Cheese"
          }
        ],
        purchase: [
          "1/3 cup Frozen Peas",
          "2-1/4 cups Chicken Broth",
          "3 Tbps. Butter",
          "1 Lemon",
          "1 Bunch Parsley (optional)"
        ],
        nutrition: {
          servings: 2.5,
          servingSize: {
            oz: 2.5,
            g: 70
          },
          showPrepared: true,
          calories: {
            base: 240,
            basePrep: 350,
            fat: 20,
            fatPrep: 110
          },
          fat: {
            total: {
              percent: 3,
              percentPrep: 18,
              g: 2
            },
            sat: {
              percent: 5,
              percentPrep: 35,
              g: 1
            },
            trans: {
              g: 0
            }
          },
          cholesterol: {
            percent: 2,
            percentPrep: 10,
            mg: 5
          },
          sodium: {
            percent: 13,
            percentPrep: 49,
            mg: 320
          },
          carbs: {
            total: {
              percent: 17,
              percentPrep: 18,
              g: 51
            },
            fiber: {
              percent: 12,
              percentPrep: 16,
              g: 3
            },
            sugar: {
              g: 2
            }
          },
          protein: {
            g: 7
          },
          vitamin: {
            a: 0,
            aPrep: 15,
            c: 8,
            cPrep: 15,
            calcium: 6,
            calciumPrep: 8,
            iron: 10,
            ironPrep: 10
          }
        },
        ingredients:
          "Arborio rice, seasoning blend (rice flour, sugar, salt, garlic, sodium citrate, spices, sunflower oil), vegetable blend (onion, mushroom), parmesan cheese ([pasteurized part-skim milk, cheese culture, salt, enzymes], cellulose powder to prevent caking, potassium sorbate to protect flavor.)",
        allergy: "Milk."
      }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/json/products.js